<div class="dialog-content">
  <div class="close" (click)="toppsTrikalaDialogRef.close()"></div>

  <div class="external-wrapper" (click)="toppsTrikalaDialogRef.close()"></div>

  <video controls poster="/assets/img/anatomy/tutorial-triceratops.png">
    <source src="/assets/videos/tutorial-triceratops.mp4" type="video/mp4">
    <img src="/assets/img/anatomy/tutorial-triceratops.png">
    Sorry, your browser doesn't support embedded videos.
  </video>
</div>
